import { AutoComplete, Icon } from 'antd'
import 'antd/lib/auto-complete/style/index.css'
import React from 'react'
import { AutoCompleteProps } from './interface'
import { Field, StyledAutoComplete, StyledInput } from './style'

const { Option, OptGroup } = AutoComplete

const PortalAutocomplete: React.FC<AutoCompleteProps> = (props) => {
  let options: React.ReactElement[] = []
  if (!props.options) {
    return null
  }
  if (props.single) {
    options = props.options.map((option) => (
      <Option key={option.id || option.title} value={option.id || option.title}>
        {option.title}
      </Option>
    ))
  } else {
    options = props.options.map((group) => (
      <OptGroup key={group.title} label={group.title}>
        {group.children &&
          group.children.map((opt) => (
            <Option key={opt.id || opt.title} value={opt.id || opt.title}>
              {opt.title}
            </Option>
          ))}
      </OptGroup>
    ))
  }

  const icon = props.icon || <Icon onClick={props.onSearchClick} data-key="max-input__submit" type="search" />

  const ComponentBody = (
    <StyledAutoComplete dataSource={props.dataSource || options} {...props}>
      <StyledInput suffix={icon} />
    </StyledAutoComplete>
  )

  if (props.label) {
    return (
      <Field label={props.label} disableMargin={props.disableMargin}>
        {ComponentBody}
      </Field>
    )
  }

  return ComponentBody
}

PortalAutocomplete.defaultProps = {
  optionLabelProp: 'text',
  filterOption: true,
  optionFilterProp: 'children',
  icon: null,
}

export default PortalAutocomplete
